import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import compact from 'lodash/compact';
import useForceUpdate from 'use-force-update';
import {EVENT} from 'avcore';
import {Utils} from 'avcore/client';

import VideoAvatar from '../VideoAvatar/VideoAvatar';

const useStyles = makeStyles({
    videoPlate: {
        width: '100%',
        height: '100%',
    },
    activeStreamsVideoPlate: {
        position: 'absolute',
        width: 100,
        height: 80,
        right: 0,
        top: 0,
        zIndex: 150,
        overflow: 'hidden',
        border: '1px solid #fff',
        backgroundColor: '#000',
    },
    video: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    userName: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    hidden: {
        display: 'none',
    },
});

const VideoPlayerSelfVideo = ({activeStreamsCount, selfVidRef, selfPlayback, user, startVideo}) => {
    const classes = useStyles();
    const forceUpdate = useForceUpdate();

    const update = ({kind}) => {
        if (kind === 'video')
            setTimeout(() => {
                if (Utils.isFirefox && selfVidRef.current) selfVidRef.current.play();
                forceUpdate();
            });
    };
    selfPlayback.api._client.on(EVENT.STREAM_STARTED, update);
    selfPlayback.api._client.on(EVENT.STREAM_STOPPED, update);

    useEffect(() => {
        (async () => await startVideo(selfVidRef, selfPlayback))();
    }, [selfPlayback, selfVidRef, startVideo]);

    const isCameraOff = !selfPlayback.availableKinds.includes('video');

    const isActiveStreams = activeStreamsCount > 0;
    return (
        <div className={compact([isActiveStreams ? classes.activeStreamsVideoPlate : classes.videoPlate]).join(' ')}>
            {isCameraOff && (
                <div className={classes.userName}>
                    <VideoAvatar member={user} isMinified={isActiveStreams} />
                </div>
            )}
            <video
                className={compact([classes.video, isCameraOff ? classes.hidden : null]).join(' ')}
                ref={selfVidRef}
                id="playback-video-self"
                muted={true}
                playsInline={true}
            ></video>
        </div>
    );
};

export default VideoPlayerSelfVideo;
